import { fromStringToBoolean } from '@seeneco-ui/core/utils/serializer';

//@ts-ignore
import * as securitypackage from '@securitypackage-api';


export type SendEmailNotificationOptions = {
	to: string;
	templateFileName: string;
};

const securityApi = {
	package: securitypackage as typeof securitypackageApi,
	directory: {
		client: new securitypackage.DirectoryServiceClient() as DirectoryServiceClient,
		sendEmailNotification: (options: SendEmailNotificationOptions) => {
			const {
				to,
				templateFileName,
			} = options;

			return new Promise<boolean>(resolve => {
				securityApi.directory.client.sendEmailNotificationByTemplate(to, templateFileName, {}, result => {
					resolve(fromStringToBoolean(result));
				});
			});
		}
	},
};

export default securityApi;
